import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import Element from '~/src/components/element/Element';
import HtmlText from '~/src/components/htmlText/HtmlText';
import {SettingsContext} from '~/src/components/context/SettingsContext';

import {classNames} from '~/src/utilities/helpers/css';

import css from './Caption.module.scss';

const Caption = (props) => {
    const {children, format, captionTitle, caption, credit, isTitleElement} = props;
    const {siteArea} = useContext(SettingsContext);
    const classes = classNames(css, 'caption', siteArea, format, {isTitleElement});

    return (
        <figure className={classes}>
            {children}
            <figcaption className={css.captionContainer}>
                {captionTitle && !isTitleElement && (
                    <span className={css.captionTitleText}>
                        <HtmlText htmlText={captionTitle} />
                    </span>
                )}
                {caption && !isTitleElement && (
                    <div className={css.captionText}>
                        {caption.elements.map((element, index) => {
                            return <Element key={index} {...element} />;
                        })}
                    </div>
                )}
                {credit && (
                    <span className={css.creditsText}>
                        <HtmlText htmlText={credit} />
                    </span>
                )}
            </figcaption>
        </figure>
    );
};

if (process.env.NODE_ENV === 'development') {
    Caption.propTypes = {
        captionTitle: PropTypes.string,
        caption: PropTypes.node,
        credit: PropTypes.string
    };
}

export default Caption;
